// Unit conversion helpers — DB stores metric, frontend converts for display.
// Mirror of backend/src/options.ts so the SPA doesn't need a network round-trip
// just to render a unit toggle.

export const KG_PER_LB = 0.45359237;
export const CM_PER_INCH = 2.54;

export const lbToKg = (lb: number): number => +(lb * KG_PER_LB).toFixed(2);
export const kgToLb = (kg: number): number => +(kg / KG_PER_LB).toFixed(1);
export const inchesToCm = (inches: number): number => +(inches * CM_PER_INCH).toFixed(1);
export const cmToInches = (cm: number): number => +(cm / CM_PER_INCH).toFixed(1);

export type FeetInches = { feet: number; inches: number };

export const cmToFeetInches = (cm: number): FeetInches => {
  const totalInches = cm / CM_PER_INCH;
  const feet = Math.floor(totalInches / 12);
  const inches = +(totalInches - feet * 12).toFixed(1);
  return { feet, inches };
};

export const feetInchesToCm = (feet: number, inches: number): number =>
  +((feet * 12 + inches) * CM_PER_INCH).toFixed(1);

export function formatWeight(kg: number | null, pref: 'metric' | 'imperial'): string {
  if (kg === null || !Number.isFinite(kg)) return '—';
  return pref === 'imperial' ? `${kgToLb(kg)} lb` : `${kg.toFixed(1)} kg`;
}

export function formatHeight(cm: number | null, pref: 'metric' | 'imperial'): string {
  if (cm === null || !Number.isFinite(cm)) return '—';
  if (pref === 'imperial') {
    const { feet, inches } = cmToFeetInches(cm);
    return `${feet}'${Math.round(inches)}"`;
  }
  return `${Math.round(cm)} cm`;
}
